import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { NavigationEnd, Router } from "@angular/router";
import { Preferences } from "@capacitor/preferences";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { NotificationResponse } from "../../../interfaces/responses/models";
import { LocalStorageService } from "../../../services/local-storage.service";
import { NotificationService } from "../../../services/notification.service";
import { ScreenSizeService } from "../../../services/screen-size.service";
import { NotificationComponent } from "../notification/notification.component";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.css"],
})
export class ProfileComponent implements OnInit, OnDestroy {
  public hygge_name: string = "";
  private notifications: NotificationResponse[] = [];
  private notificationSubscription: Subscription | null = null;
  isMobile: boolean = false;
  isSidebarOpen: boolean = false;
  showBackArrow: boolean = false;
  showBescomLogoOnMarket: boolean = false;
  numberOfNotifications: number = 0;
  isUnreadFlag: boolean = false;
  public isDropdownOpen = false; 

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    private screenSizeService: ScreenSizeService,
    private notificationService: NotificationService
  ) {}

  async ngOnInit() {
    this.checkBackArrowVisibility();
    this.checkBescomLogoVisibility();
    this.hygge_name = this.localStorageService.getUser();
    this.notifications = await this.localStorageService.getNotifications();
    this.isUnreadFlag = await this.localStorageService.getUnreadNotification();
    this.numberOfNotifications = await this.localStorageService.getUnreadNotificationCount();

    this.connectToNotifications();
    this.screenSizeService.isMobile$.subscribe((isMobile) => {
      this.isMobile = isMobile;
    });
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkBackArrowVisibility();
        this.checkBescomLogoVisibility();
      });
    this.numberOfNotifications = this.notifications.length;
  }


  @HostListener("document:click", ["$event"])
  @HostListener("document:touchstart", ["$event"])
  onOutsideClick(event: Event): void {
    const target = event.target as HTMLElement;


    const sidebar = document.querySelector(".sidebar");
    const mobileMenuTrigger = document.querySelector(".panchami-mobile-logo");
    if (this.isSidebarOpen && sidebar && !sidebar.contains(target) && !mobileMenuTrigger?.contains(target)) {
      this.isSidebarOpen = false;
    }


    const dropdownTrigger = document.querySelector(".dropbtn");
    const dropdownContent = document.querySelector(".dropdown-content");
    if (this.isDropdownOpen && !dropdownTrigger?.contains(target) && !dropdownContent?.contains(target)) {
      this.isDropdownOpen = false;
    }

    this.cdr.detectChanges();
  }

  checkBescomLogoVisibility() {
    const pathsToShowBescomLogo = ["market"];
    this.showBescomLogoOnMarket = pathsToShowBescomLogo.some((path) =>
      this.router.url.includes(path)
    );
  }

  checkBackArrowVisibility() {
    const pathsToShowBackArrow = ["strike", "allocation", "fixed-rate-bid", "buy", "sell", "account", "history"];
    this.showBackArrow = pathsToShowBackArrow.some((path) =>
      this.router.url.includes(path)
    );
  }
  
  // Method to toggle the dropdown's visibility
  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  isLoggedUser(): boolean {
    const role = this.localStorageService.getRole();
    return role === "Prosumer" || role === "Consumer" || role === "Admin";
  }

  async connectToNotifications(): Promise<void> {
    if (!(await this.localStorageService.getToken()) || !this.isLoggedUser()) {
      return;
    }

    this.notificationSubscription = this.notificationService.connect().subscribe(async (newNotification) => {
      let existingNotifications = await this.localStorageService.getNotifications();
      const notificationAlreadyExists = existingNotifications.some(
        (notification) =>
          notification.message === newNotification.message &&
          notification.url === newNotification.url
      );

      if (!notificationAlreadyExists) {
        existingNotifications.push(newNotification);
        await this.localStorageService.setNotifications(existingNotifications);
        const newCount = await this.localStorageService.incrementUnreadNotificationCount();
        this.numberOfNotifications = newCount;
      }
      this.notifications = existingNotifications;
      await this.localStorageService.setUnreadNotification(true);
      this.isUnreadFlag = true;
    });
  }

  ngOnDestroy() {
    if (this.notificationSubscription) {
      this.notificationSubscription.unsubscribe();
    }
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  async logout() {
    this.localStorageService.clear();
    await Preferences.clear();
    this.navigateTo("/welcome");
  }

  navigateTo(path: string) {
    this.router.navigate([path]);
    this.isSidebarOpen = false;
    this.isDropdownOpen = false; // Close dropdown on navigation
  }

 async openNotifications(): Promise<void> {
  if (!this.hygge_name) return;


  this.isDropdownOpen = false;


  await this.localStorageService.setUnreadNotification(false);
  this.isUnreadFlag = false;
  
  await this.localStorageService.setUnreadNotificationCount(0);
  this.numberOfNotifications = 0; 
  

  if (this.isSidebarOpen) {
    this.toggleSidebar();
  }
  
  this.notifications = await this.localStorageService.getNotifications();
  this.dialog.open(NotificationComponent, { data: this.notifications });
}
  get isUnread(): boolean {
    return this.isUnreadFlag;
  }

  isCustomer(): boolean {
    const role = this.localStorageService.getRole();
    return role === "Prosumer" || role === "Consumer";
  }
}